export enum DRIVE_TRAIN_CREATION_OPTION {
  UPDATE_DRIVE_TRAIN_INFORMATION = 'updateDriveTrainInformation',
}
